import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { isDefaultOldApiAvatar } from '../../../utils/user'
import { SearchItem } from '../../Search'

import { PROVIDER_SEARCH_ITEM_ICON } from './ProviderSearchItem.constants'
import { getProviderSearchItemTitle } from './ProviderSearchItem.utils'

import * as styles from './ProviderSearchItem.module.css'

function ProviderSearchItem({ className = styles.ProviderSearchItem, value }) {
  const { archived, avatar, email, group, name, phone, website } =
    value.item ?? EMPTY_OBJECT

  const { t } = useTranslation()

  const additional = [email, phone, website]

  const title = getProviderSearchItemTitle({ group, name, t })

  const icon =
    avatar && !isDefaultOldApiAvatar(avatar)
      ? {
          src: avatar,
          text: name,
        }
      : PROVIDER_SEARCH_ITEM_ICON

  return (
    <SearchItem
      additional={additional}
      archived={archived}
      className={className}
      icon={icon}
      title={title}
    />
  )
}

export default ProviderSearchItem
